import axios from "axios";
import { NotImplementedError } from "../../errors";
import { UXConfigHandler } from "../../handlers/ux";
import { parseIdFilter } from "../../handlers/filter";
class Switches extends UXConfigHandler {
    constructor(sdk) {
        super(sdk, "switches");
    }
    /**
     * Currently we don't need to support filtering on the find
     * @returns
     */
    async findItems(filters) {
        const idFilter = parseIdFilter(filters);
        const promise = idFilter.size === 1
            ? this.getSwitch(idFilter.values().next().value).then((_switch) => [_switch])
            : this.getSwitches();
        return await promise;
    }
    getSwitch(id) {
        return this.cache.promise(id, () => axios
            .get(`${this.sdk.urls.baseAPIUrl}/ux/switch/${id}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            // API is returning an array for single item requests.
            .then((res) => res.data?.data?.[0]));
    }
    getSwitches() {
        const url = `${this.sdk.urls.baseAPIUrl}/ux/switches`;
        return this.cache.promise(url, () => axios
            .get(url, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => res.data.data || []));
    }
    /**
     * API to save switches takes an array of partial or full switches and will update/create them
     * @param switchData The switch data to update
     * @returns Promise that will resolve with the created/updated switch
     */
    async saveItem(switchData) {
        return axios
            .post(`${this.sdk.urls.baseAPIUrl}/ux/switches`, [switchData], {
            headers: { "Content-Type": "application/json" }
        })
            .then((saved) => {
            return saved.data.data[0];
        });
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
export default Switches;
//# sourceMappingURL=switches.js.map